var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "15",
        height: "16",
        viewBox: "0 0 15 16",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M7.50655 0.00131553C4.87419 -0.059902 2.66141 2.02272 2.65738 4.72187C2.59985 7.37196 4.75415 9.50262 7.37065 9.56347L7.38547 9.56364C8.49502 9.56364 9.51828 9.19293 10.335 8.56648L13.2113 11.3499C13.4643 11.5948 13.8678 11.5882 14.1127 11.3352C14.3575 11.0821 14.3509 10.6786 14.0979 10.4337L11.2357 7.6638C11.8321 6.88226 12.195 5.9111 12.2197 4.85034C12.2814 2.1968 10.1255 0.0622208 7.50655 0.00131553ZM3.93237 4.72927C3.93237 2.75701 5.54292 1.23099 7.4769 1.27597C9.42673 1.32132 10.9896 2.90549 10.945 4.8207C10.9001 6.75436 9.32958 8.28474 7.39288 8.28863C5.44652 8.23946 3.88771 6.65688 3.9322 4.74409L3.93237 4.72927Z",
          fill: "currentColor"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M0.6375 5.3125C0.989581 5.3125 1.275 5.59792 1.275 5.95V15.0344C1.275 15.3865 0.989581 15.6719 0.6375 15.6719C0.285418 15.6719 0 15.3865 0 15.0344V5.95C0 5.59792 0.285418 5.3125 0.6375 5.3125Z",
          fill: "currentColor"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M4.03771 10.1469C4.38979 10.1469 4.67521 10.4323 4.67521 10.7844V15.0344C4.67521 15.3865 4.38979 15.6719 4.03771 15.6719C3.68563 15.6719 3.40021 15.3865 3.40021 15.0344V10.7844C3.40021 10.4323 3.68563 10.1469 4.03771 10.1469Z",
          fill: "currentColor"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M8.07541 12.8563C8.07541 12.5042 7.79 12.2188 7.43792 12.2188C7.08583 12.2188 6.80042 12.5042 6.80042 12.8563V15.0345C6.80042 15.3866 7.08583 15.672 7.43792 15.672C7.79 15.672 8.07541 15.3866 8.07541 15.0345V12.8563Z",
          fill: "currentColor"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }